
const formatTwelveHour = (time, fix) => {
    if (!time) return '';
    let [hour, minute] = time.split(':');
    let ampm = hour >= 12 ? 'pm' : 'am';
    hour = hour % 12;
    hour = hour ? hour : 12;
    return `${hour}:${minute} ${ampm}` + (fix || '');
};
export default formatTwelveHour;